module.exports = __webpack_public_path__ + "img/level_three.e5f2ce39.png";